import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
	state: false,
	status : null,
	options: {
		children: null
	}
};
const newsLetterDialog = createSlice({
	name: 'newsLetter',
	initialState: initialState,
	reducers: {
		openDialog: (state: any) => {
			state.state = true;
		},
		closeDialog: (state: any) => ({
			...initialState
		})
	}
});

export const { openDialog, closeDialog} = newsLetterDialog.actions;

export default newsLetterDialog.reducer;
